import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Services
export const getServices = async () => {
    const response = await api.get('/services');
    return response.data;
};

export const createService = async (serviceData) => {
    const response = await api.post('/services', serviceData);
    return response.data;
};

// Bookings
export const createBooking = async (bookingData) => {
    const response = await api.post('/bookings', bookingData);
    return response.data;
};

export const getBookings = async () => {
    const response = await api.get('/bookings');
    return response.data;
};

// Reviews
export const getReviews = async () => {
    const response = await api.get('/reviews');
    return response.data;
};

export const createReview = async (reviewData) => {
    const response = await api.post('/reviews', reviewData);
    return response.data;
};

export default api;